export default "__VITE_ASSET__c_neMayk__"